import { render, staticRenderFns } from "./pos-Expenses.vue?vue&type=template&id=ccec2cbe"
import script from "./pos-Expenses.vue?vue&type=script&lang=js"
export * from "./pos-Expenses.vue?vue&type=script&lang=js"
import style0 from "./pos-Expenses.vue?vue&type=style&index=0&id=ccec2cbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports